import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import ReactPlayer, { ReactPlayerProps } from 'react-player';

export interface SubtitleConfig {
    src: string; // url
    srcLang: "en-US" | "es-US" | "en-AU"; // us, es that thing
    label?: string; // this is what shows on the page
}

export interface VideoPlayerProps {
    src: string;
    subtitles?: SubtitleConfig[];

    // Pulled from ReactPlayerProps
    playing?: boolean;
    loop?: boolean;
    controls?: boolean;
    width?: string | number;
    height?: string | number;
    muted?: boolean;
    onReady?(): void;
    onStart?(): void;
    onPlay?(): void;
    onPause?(): void;
    onBuffer?(): void;
    onEnded?(): void;
    onError?(error: any): void;
    onDuration?(duration: number): void;
    onSeek?(seconds: number): void;
    onProgress?(state: { played: number, playedSeconds: number, loaded: number, loadedSeconds: number }): void;
}

class VideoPlayer extends React.Component<VideoPlayerProps> {
    constructor(props: VideoPlayerProps) {
        super(props);
        bindAllOfThis(this, VideoPlayer.prototype);
    }

    onReady() {
        let videoElement = document.getElementById("react-player").getElementsByTagName("video")[0];
        if (videoElement != null) {
            videoElement.crossOrigin = "anonymous";
        }
        if (this.props.onReady != null) {
            this.props.onReady();
        }

        // Since FF cannot deal with the azure URLs, they must be turned into blobs
        // This works with chrome without issue and im sure will break the iPad for no reason other than that Safari devs just hate us
        this.props.subtitles.forEach(subtitle => {
            if (subtitle.src == null) {
                return;
            }
            fetch(subtitle.src)
                .then(response => response.text()) // Get the string of the response
                .then(text => {
                    let blob = new Blob([text], { type: "text/vtt" });
                    let blobUrl = URL.createObjectURL(blob);

                    let track = document.createElement("track");
                    track.kind = "subtitles";
                    track.label =  subtitle.label || subtitle.srcLang;
                    track.srclang = subtitle.srcLang;
                    track.src = blobUrl;
                    videoElement.appendChild(track);
            });
        });
    }

    generateConfig() {
        if (this.props.subtitles == null || this.props.subtitles.length < 1) {
            return {};
        }
        return {
            file: {
                tracks: this.props.subtitles.map(x => {
                    return {
                        src: x.src,
                        kind: "subtitles",
                        srcLang: x.srcLang,
                        label: x.label || x.srcLang
                    };
                })
            }
        };
    }

    render() {
        let coolProps: ReactPlayerProps = {
            ...this.props,
            url: this.props.src,
            // config: this.generateConfig()
        };

        return <ReactPlayer {...coolProps} onReady={this.onReady} id="react-player"  />;
    }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/common/VideoPlayer.tsx